export default function DOM_GetValues() {
  return (
    <div>
      <h1>DOM_GetValues</h1>
      <p>This is the DOM_GetValues component.</p>
    </div>
  );
}